import React from 'react';
import PropTypes from 'prop-types';
import { Box, DialogTitle, DialogContentText, Typography } from '@material-ui/core';
import { 
  CheckCircleOutline as SuccessIcon,
  ErrorOutline as WarningIcon,
  HighlightOff as ErrorIcon,
} from '@material-ui/icons';
import clsx from 'classnames';
import { includes, capitalize } from 'lodash';

import { useStyles } from '../../hooks';
import styles from './styles';

const iconVariants = {
  success: SuccessIcon,
  warning: WarningIcon,
  error: ErrorIcon
};

const DialogContentSmg = ({
  icon,
  title,
  message
}) => {
  const classes = useStyles(styles);

  const IconElement = iconVariants[icon];

  return (
    <>
      { 
        icon && includes(Object.keys(iconVariants), icon) && (
          <Box className={classes.iconContainer}>
            <IconElement
              className={clsx(
                classes.icon,
                classes[`iconStatus${capitalize(icon)}`]
              )}
            />
          </Box>
        ) 
      }
      {
        title && (
          <DialogTitle disableTypography>
            <Typography component="h2" className={classes.title}>
              { title }
            </Typography>
          </DialogTitle>
        )
      }
      <DialogContentText className={classes.message}>
        { message }
      </DialogContentText>
    </>
  );
}

DialogContentSmg.propTypes = {
  icon: PropTypes.oneOf(["success", "warning", "error"]),
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
}

export default DialogContentSmg;
